import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { XylemAuthInterceptor } from './core/interceptors/xylem-auth.interceptor';
import { BaseModule, MaterialModule } from '@gravity-angular/base';
import { ComponentsModule } from '@gravity-angular/components';
import { PagesModule } from '@gravity-angular/pages';
import { UtilsModule } from '@gravity-angular/utils';

import { PortalModule } from '@angular/cdk/portal';
import { LayoutModule } from '@gravity-angular/layout';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GlobalErrorHandler } from '@shared/shared.module';
import { AuthConfigModule } from './auth/oidc-config/auth-config.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    LayoutModule,
    MaterialModule,
    PagesModule,
    ComponentsModule,
    PortalModule,
    UtilsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BaseModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    AuthConfigModule
  ],
  exports: [],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      provide: HTTP_INTERCEPTORS,
      useClass: XylemAuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
